import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractLocation(sale: Element): string | undefined {
  return extractAdjustmentDescription(sale, 'Location');
}
